import axios from 'axios';
const instance = axios.create()
instance.defaults.baseURL = 'https://api.youths.run';
// 换取openId
const getOpenId = (param) => {
  return instance.get('/v1/pay/code2session', {
    params: param
  })
}

// 查询订单信息
const getOrderDetail = (param) => {
  return instance.get(`/v1/pay/inner/query`, {
    params: param
  })
}

// 下单接口
const booking = (param) => {
  return instance.get('/v1/pay/inner/reorder', {
    params: param
  })
}

// 微信配置
const weixinConfig = (param) => {
  return instance.get('/v1/pay/wxconfig',{
    params:param
  })
}

export {
  getOpenId,
  getOrderDetail,
  booking,
  weixinConfig
}



// WEBPACK FOOTER //
// ./src/api/index.js